import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import 'core-js'
import React from 'react'
import { render } from 'react-dom'
import Modal from 'react-modal'
import { cache } from 'swr'
import 'whatwg-fetch'
import { changeLanguage } from './transifex/transifex'

import AppProvider from './AppProvider'

import './index.css'

require('dayjs/locale/sv')
require('dayjs/locale/en')
require('dayjs/locale/es')

require('moment/locale/sv')
require('moment/locale/en-gb')
require('moment/locale/es')

const rootEl = document.getElementById('root')

Modal.defaultStyles.overlay.zIndex = 9999999999
Modal.defaultStyles.content.zIndex = 9999999999
Modal.setAppElement(rootEl)

window.dataLayer = window.dataLayer || []
window.dataLayer.push({
  userType: localStorage.userType,
})

window.fullCol = { xs: 12, sm: 12, md: 12, lg: 12 }

const availableLocales = ['en', 'sv']

const cleanedLocale = window.navigator.language.split('-')[0]

const savedLocale = localStorage.getItem('language')

const browserLocale = availableLocales.includes(cleanedLocale) ? cleanedLocale : 'en'

const locale = savedLocale || browserLocale
changeLanguage(locale)

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://d3cfaa2206c843b487a0bc1353d75679@o458314.ingest.sentry.io/5464599',
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.01,
  })
}

if (process.env.NODE_ENV === 'development') {
  window.cache = cache
}

render(<AppProvider />, rootEl)
